import React from "react";
import { withRouter } from "react-router-dom";

import moment from "moment";

import { Modal, Popover, OverlayTrigger, Dropdown, MenuItem, ButtonToolbar, Button as BsButton } from "react-bootstrap";
import { toast } from "react-toastify";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faDatabase,
  faChartBar,
  faList,
  faDotCircle,
  faCircle,
  faMapMarker,
  faPlay,
  faPause,
  faFastForward,
  faTh,
  faEdit,
  faComments,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faUsers
} from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import { SetupText } from "components/Next/Models/Models";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import LeakageChart from "components/Next/Charts/LeakageChart";
import DistributionChart from "components/Next/Charts/DistributionChart";
import OutcomeChart from "components/Next/Charts/OutcomeChart";

import ImpactSlider from "components/Optimizer/ImpactSlider";
import OptimizeWarnings from "components/UnifiedProject/Optimize/Double/OptimizeWarnings";

import Thumbtack from "images/Thumbtack.svg";
import FullPin from "images/Next-Icons/FullPin.svg";
import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import SecondVarIcon from "images/Next-Icons/drill-in-1.svg";
import TelescopeIcon from "images/Next-Icons/mode-voting.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import VotingIcon from "images/Next-Icons/model-voting.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";
import PPTDownloadIcon from "images/Next-Icons/PPTDownloadIcon.svg";
import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";
import AibleIcon from "images/Next-Icons/AibleIcon.png";

import IntegrateIcon from "images/Next-Icons/IntegrateIcon.svg";
import MonitorSettingsIcon from "images/Next-Icons/MonitorSettingsIcon.svg";

import PredictIcon from "images/Next-Icons/PredictIcon.svg";
import BusinessIcon from "images/Next-Icons/BusinessIcon.svg";
import FairnessIcon from "images/Next-Icons/FairnessIcon.svg";
import ResourceIcon from "images/Next-Icons/ResourceIcon.svg";
import RocketIcon from "images/Next-Icons/RocketIcon.svg";

import MagnifierIcon from "images/Next-Icons/MagnifierIcon.svg";
import HexIconBackground from "images/Next-Icons/HexIconBackground.svg";
import CheckmarkIcon from "images/Next-Icons/CheckmarkIcon.svg";
import PurpleBlueprintIcon from "images/Next-Icons/PurpleBlueprintIcon.svg";
import PurpleCompassIcon from "images/Next-Icons/PurpleCompassIcon.svg";
import FunnelIcon from "images/Next-Icons/FunnelIcon.svg";
import CashIcon from "images/Next-Icons/CashIcon.svg";
import HeartLifelineIcon from "images/Next-Icons/HeartLifelineIcon.svg";
import StethoscopeIcon from "images/Next-Icons/StethoscopeIcon.svg";
import LabVialIcon from "images/Next-Icons/LabVialIcon.svg";
import SecurityCheckIcon from "images/Next-Icons/SecurityCheckIcon.svg";
import WaypointIcon from "images/Next-Icons/WaypointIcon.svg";
import BullseyeIcon from "images/Next-Icons/BullseyeIcon.svg";
import MiniFunnelIcon from "images/Next-Icons/MiniFunnelIcon.svg";
import NewMoneyIcon from "images/Next-Icons/NewMoneyIcon.svg";
import FairnessScalesIcon from "images/Next-Icons/FairnessScalesIcon.svg";
import ExpertIcon from "images/Next-Icons/ExpertIcon.svg";
import ResumeIcon from "images/Next-Icons/ResumeIcon.svg";
import MicroscopeIcon from "images/Next-Icons/MicroscopeIcon.svg";
import ReturnIcon from "images/Next-Icons/ReturnIcon.svg";
import GearsIcon from "images/Next-Icons/GearsIcon.svg";
import ChartIcon from "images/Next-Icons/ChartIcon.svg";
import SpreadsheetIcon from "images/Next-Icons/SpreadsheetIcon.svg";
import ScalesIconWhiteBackground from "images/Next-Icons/ScalesIconWhiteBackground.svg";
import TodoAssignIcon from "images/Next-Icons/TodoAssignIcon.svg";
import TodoFeedbackIcon from "images/Next-Icons/TodoFeedbackIcon.svg";
import TodoPinIcon from "images/Next-Icons/TodoPinIcon.svg";
import TodoAddIcon from "images/Next-Icons/TodoAddIcon.svg";
import TodoXIcon from "images/Next-Icons/TodoXIcon.svg";

import HexGridContainer from "containers/Next/HexGrid";
import NextSearchContainer from "containers/Next/NextSearch";
import HexagonContainer from "containers/Next/Hexagon";
import MinimapViewContainer from "containers/Next/MinimapView";
import NextReportContainer from "containers/Next/NextReport";
import CommentModalContainer from "containers/Next/Comments/CommentModal";
import TransformContainer from "containers/Next/Transform/Transform";
import ModelsContainer from "containers/Next/Models/Models";
import OverviewContainer from "containers/Next/Overview/Overview";
import SubgroupContainer from "containers/Next/Subgroup/Subgroup";
import IntrospectContainer from "containers/Next/Strategy/Introspect";
import DeploySettingsContainer from "containers/Next/Deploy/DeploySettings";
import TrainContainer from "containers/UnifiedProject/Train/Train";
import AdvancedCostsContainer from "containers/CreateWizard/Costs/AdvancedCosts";
import BaselineCostsCardContainer from "containers/UnifiedProject/RealityCheck/BaselineCostsCard";
import OptimizeContainer from "containers/UnifiedProject/Optimize/Optimize";

import SubgroupMenuContainer from "containers/Business/SubgroupMenu/SubgroupMenu";

import NextFooterContainer from "containers/Next/Footer/NextFooter";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";

import SelectDataWrapperContainer from "containers/UnifiedProject/SelectData/SelectDataWrapper";
import ObjectiveContainer from "containers/UnifiedProject/Objective/Objective";
import RealityCheckContainer from "containers/UnifiedProject/RealityCheck/RealityCheck";
import StrategyContainer from "containers/Business/Strategy/Strategy";
import BusinessConstraintsContainer from "containers/Business/Strategy/BusinessConstraints";
import OptimizationContainer from "containers/Business/Optimization/Optimization";
import ModelListContainer from "containers/Business/ModelList/ModelList";
import PredictContainer from "containers/UnifiedProject/TestPredictions/TestPredictions";

import MonitorContainer from "containers/Monitoring/Monitoring";

import DeployContainer from "containers/UnifiedProject/Deploy/Deploy";
import IntegrateContainer from "containers/UnifiedProject/Integrate/Integrate";

import MarketContainer from "containers/Market/Market";
import CreateJobModalContainer from "containers/Market/Jobs/CreateJobModal";

import GalleryContainer from "containers/Gallery/Gallery";

import { centerHex } from "containers/Next/NextReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as wizardReducer from "containers/Wizard/reducer";
import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";

import DoubleOutcomeChart from "components/Next/Charts/DoubleOutcomeChart";

import { CHART_TYPES } from "containers/Report/ReportReducer";
import { readableSearch } from "containers/Next/Models/ModelsReducer";

import styles from "./style.module.css";

export default class Task extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isCreatingVersion: false };
  }

  renderTaskSetup(taskObj) {
    const { id, datasetId, projectId, blueprintId, runId, updateViewTask, saveVersion, optimized, isOverallSegment } =
      this.props;

    const task = taskObj?.type;

    const retProps = {
      id: blueprintId === "new" ? "new" : blueprintId !== undefined && projectId === undefined ? runId : projectId,
      runId: blueprintId === "new" ? "new" : projectId === "new" ? "new" : runId,
      datasetId: datasetId,
      nextId: id,
      isNext: true,
      isModelsNext: true,
      hideModel: true
    };

    const buttonStyle = { padding: "3px", fontWeight: "normal" };

    const retIsMax = true;
    const isList = false;

    return (
      <div className={styles.todoSection}>
        <div className={styles.todoHeaderStatic}>
          {task && (
            <div className={styles.hexIcon}>
              <img
                src={
                  task === "DEPLOY_REVIEW"
                    ? ReviewDeployIcon
                    : task === "DEPLOY_INTEGRATION"
                      ? IntegrateIcon
                      : task === "DEPLOY_MONITOR"
                        ? MonitorSettingsIcon
                        : task === "OPTIMIZE_STRATEGY"
                          ? BullseyeIcon
                          : task === "OPTIMIZE_TRANSACTION"
                            ? MiniFunnelIcon
                            : task === "OPTIMIZE_COSTS"
                              ? NewMoneyIcon
                              : task === "OPTIMIZE_BLUEPRINT"
                                ? WaypointIcon
                                : task === "PREDICT_WHAT_IF"
                                  ? StethoscopeIcon
                                  : task === "DEPLOY_REVIEW"
                                    ? LabVialIcon
                                    : task === "FAIR_GUIDE"
                                      ? ScalesIconWhiteBackground
                                      : task === "FAIR_VALUE"
                                        ? SecurityCheckIcon
                                        : task === "BUDGET_SUBGROUP"
                                          ? MicroscopeIcon
                                          : task === "BUDGET_RETRAIN"
                                            ? ReturnIcon
                                            : task === "EVAL_MODEL_DRIVERS"
                                              ? GearsIcon
                                              : task === "REVIEW_MODEL_METRICS"
                                                ? SpreadsheetIcon
                                                : task === "REVIEW_MODEL_CHARTS"
                                                  ? ChartIcon
                                                  : null
                }
              />
            </div>
          )}
          <div className={styles.todoText}>{readableSearch[task] || task}</div>
          <div className={styles.tActions}>
            {isOverallSegment ? (
              <div />
            ) : this.state.isCreatingVersion === true ? (
              <LoadingIndicator
                style={{
                  margin: "0px",
                  transform: "scale(0.75)",
                  marginLeft: "-70px",
                  marginTop: "-33px",
                  position: "absolute"
                }}
              />
            ) : (
              <Button
                onClick={() => {
                  // Hacky cooldown timer for save button
                  this.setState({ isCreatingVersion: true });
                  setTimeout(() => this.setState({ isCreatingVersion: false }), 1000);
                  saveVersion(taskObj);
                }}
                style={buttonStyle}
                type="primary"
              >
                {"Save"}
              </Button>
            )}
          </div>
        </div>
        <div
          className={styles.todoBody}
          style={
            retIsMax && task === "OPTIMIZE_COSTS"
              ? {
                  maxHeight: isList ? "calc(80vh - 200px)" : "calc(100vh - 220px)"
                }
              : retIsMax && (task === "REVIEW_MODEL_METRICS" || task === "REVIEW_MODEL_CHARTS")
                ? {
                    height: isList ? "calc(80vh - 200px)" : "calc(100vh - 220px)",
                    maxHeight: "100vh"
                  }
                : retIsMax
                  ? {
                      height: isList ? "calc(80vh - 200px)" : "calc(100vh - 220px)",
                      maxHeight: "100vh"
                    }
                  : { maxHeight: "0px" }
          }
        >
          {task === "OPTIMIZE_BLUEPRINT" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              isBlueprintPicker={true}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              showCreateButton
              hidePicker={blueprintId === "new"}
              reportLabel={taskObj?.name}
              nextId={id}
              isSenseTask
            />
          ) : task === "OPTIMIZE_TRANSACTION" ? (
            <RealityCheckContainer {...retProps} />
          ) : task === "OPTIMIZE_BALANCER" ? (
            <OptimizeContainer {...retProps} isBalance />
          ) : task === "OPTIMIZE_COSTS_BASELINE" ? (
            <BaselineCostsCardContainer {...retProps} />
          ) : task === "OPTIMIZE_COSTS" ? (
            <div style={{ padding: "20px" }}>
              <StrategyContainer {...retProps} />
            </div>
          ) : task === "OPTIMIZE_STRATEGY" ? (
            <BusinessConstraintsContainer {...retProps} />
          ) : task === "FAIR_GUIDE" ? (
            <ObjectiveContainer {...retProps} runId={overallRunId} />
          ) : task === "FAIR_VALUE" || task === "BUDGET_SUBGROUP" ? (
            <SubgroupContainer {...retProps} blueprintId={blueprintId} />
          ) : task === "DEPLOY_INTEGRATION" ? (
            <IntegrateContainer {...retProps} />
          ) : task === "DEPLOY_MONITOR" ? (
            <DeployContainer {...retProps} isAdvancedOptions />
          ) : task === "DEPLOY_REVIEW" ? (
            <DeploySettingsContainer {...retProps} />
          ) : task === "PREDICT_WHAT_IF" ? (
            <PredictContainer id={runId} runId={runId} projectId={projectId} isNext />
          ) : task === "OUTCOME" ? (
            <SelectDataWrapperContainer
              {...retProps}
              hideBlueprint
              nextBlueprintId={blueprintId}
              type={wizardReducer.STEP_TYPE.ACADEMIC_REVIEW_DATASET.id}
              nextId={id}
            />
          ) : task === "EVAL_MODEL_DRIVERS" ? (
            <ModelListContainer {...retProps} hideModelBox />
          ) : task === "REVIEW_MODEL_METRICS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
              renderDetails
            />
          ) : task === "REVIEW_MODEL_CHARTS" ? (
            <TrainContainer
              {...retProps}
              id={optimized && optimized.innerId !== undefined ? optimized.innerId : "new"}
              projectId={projectId}
            />
          ) : task === "EVAL_MODEL_DRIVERS" ? (
            <ModelListContainer {...retProps} hideModelBox />
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  getInitialsFromText(text) {
    if (text === undefined) {
      return undefined;
    }

    const matches = text.match(/\b(\w)/g);
    return matches.join("").substring(0, 3);
  }

  renderComment(comment, index) {
    const { editComment, editFeedback, deleteFeedback, task, nextId, deleteComment } = this.props;

    return (
      <div
        key={index}
        className={styles.comment}
        style={index % 2 === 0 ? { background: "rgba(236, 236, 252, 1)" } : {}}
      >
        <div className={styles.commentStatus}>
          <div className={styles.assignCircle}>{this.getInitialsFromText(comment?.created_by?.fullname)}</div>
          <div>{comment?.created_by?.fullname}</div>
          <div
            className={styles.commentDate}
            title={moment.utc(comment?.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
          >
            {moment.utc(comment?.created_date).local().fromNow()}
          </div>
        </div>
        <div className={styles.commentText}>{comment?.message}</div>
        <div className={styles.commentButtons}>
          {/* TODO: Add Reply
          <Button style={{ height: "33px", marginRight: "20px" }}>
            {"Add Reply"}
          </Button>
          */}
        </div>
      </div>
    );
  }

  renderComments() {
    const { comments, assign, updateIsComment, task, nextId } = this.props;

    let combined = task?.comments || [];

    return (
      <React.Fragment>
        <div className={styles.commentHeader}>
          <FontAwesomeIcon icon={faComments} style={{ marginRight: "10px" }} />
          {"Comments and Feedback"}
        </div>
        <div className={styles.commentList}>
          {combined.length === 0 ? (
            <div className={styles.emptyComments}>{"No Comments or Feedback found"}</div>
          ) : (
            <div>
              {combined
                .sort((a, b) =>
                  moment(a.created_date).isBefore(moment(b.created_date))
                    ? 1
                    : moment(b.created_date).isBefore(moment(a.created_date))
                      ? -1
                      : 0
                )
                .map((c, i) => this.renderComment(c, i))}
            </div>
          )}
        </div>
        <div className={styles.newComment}>
          <CommentModalContainer id={nextId} nextId={nextId} isNoModal task={task} isModels />
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { selectedTask, project, projectId, runId, blueprintId, splitTasks, optimized, dataset, hasLoadedDataset } =
      this.props;

    const hasSplits = project && project.segments && project.segments.length > 1;

    let disabledRunIds = {};
    splitTasks &&
      splitTasks.forEach((sTask) => {
        const sRunId = sTask?.segment?.job?.job_id;
        if (Object.keys(sTask?.task).length === 0) {
          disabledRunIds[sRunId] = true;
        }
      });

    const isLoading = optimized === undefined || optimized?.isLoading === true || hasLoadedDataset !== true;

    return (
      <div className={styles.exploreTask}>
        <div className={styles.nextChart}>
          <div className={styles.taskHeader}>{project?.name}</div>
          {isLoading ? (
            <div className={styles.taskBody}>
              <div className={styles.taskLeftLoading}>
                {"Loading Task..."}
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginTop: "70px",
                    transform: "scale(2)"
                  }}
                />
              </div>
            </div>
          ) : (
            <div className={styles.taskBody}>
              <div className={styles.taskLeft}>
                {hasSplits && (
                  <SubgroupMenuContainer id={projectId} updateShow={() => {}} disabledRunIds={disabledRunIds} isNext />
                )}
                <ModelBoxContainer
                  id={projectId}
                  runId={projectId === undefined ? "new" : runId}
                  isNext
                  nextId={"new"}
                  background={blueprintId !== undefined ? "rgb(74, 144, 226)" : undefined}
                />
              </div>
              <div
                className={styles.taskRight}
                style={{
                  left: "max(33.33vw, 500px)"
                }}
              >
                {this.renderTaskSetup(selectedTask)}
              </div>
            </div>
          )}
        </div>
        <div className={styles.commentPanel}>{this.renderComments()}</div>
      </div>
    );
  }
}
